/* eslint-disable no-param-reassign */
import Joi from '@hapi/joi';
import i18next from 'i18next';

const schema = Joi.object({
  firstName: Joi.string().min(2).max(30).required(),
  lastName: Joi.string().min(2).max(30).required(),
  email: Joi.string().email({ tlds: false }).required(),
  department: Joi.string().allow('', null),
  ids: Joi.string().min(1).max(30).required(),
  jobTasks: Joi.array().items(Joi.any().required()).required(),
});

const validate = (values, type = 'create') => {
  const { error } = schema.validate(values, { abortEarly: false });

  if (!error) {
    return {};
  }

  const { details } = error;

  return details.reduce((errors, detail) => {
    switch (detail.context.key) {
      case 'firstName':
        errors[detail.context.key] = i18next.t('errors.firstNameIsRequired');
        break;
      case 'lastName':
        errors[detail.context.key] = i18next.t('errors.lastNameIsRequired');
        break;
      case 'email':
        if (detail.context.value === undefined || detail.context.value === '') {
          errors[detail.context.key] = i18next.t('errors.emailIsRequired');
        } else {
          errors[detail.context.key] = i18next.t('errors.emailIsInvalid');
        }
        break;
      case 'jobTasks':
        if (type !== 'edit') {
          errors[detail.context.key] = i18next.t('errors.jobTasksIsRequired');
        }
        break;
      case 'ids':
        errors[detail.context.key] = i18next.t('errors.idNumberIsRequired');
        break;
      default:
        break;
    }
    return errors;
  }, {});
};

export default validate;
